import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import SvgComponent from 'components/Form/SvgComponent';
import './SectionNavButton.scss';

interface Props {
  link: string
  direction: string
  label: string
}

const SectionNavButton = React.forwardRef<HTMLAnchorElement, Props>(
  ({ link, direction, label }, ref) => {
    if (!link || !label) {
      return <div className="btn-cell" />;
    }

    const directionText = direction === 'next' ? 'Next' : 'Back';
    const ariaDirectionText = direction === 'next' ? 'next' : 'previous';
    const directionClass = direction === 'next' ? 'next' : 'back';
    const iconClass = direction === 'next' ? 'arrow-circle-right' : 'arrow-circle-left';
    const ariaLabel = `Go to ${ariaDirectionText} section ${label}`;

    const icon = (
      <div className={iconClass}>
        <SvgComponent className={iconClass} src={direction === 'next' ? "/img/arrow-circle-right.svg" : "/img/arrow-left.svg"} />
      </div >
    );

    return (
      <Link
        innerRef={ref}
        className={classnames('btn-cell', { [directionClass]: directionClass && link })}
        title={ariaLabel}
        aria-label={ariaLabel}
        to={link}
      >
        {link && (
          <div className={classnames('actions', { [directionClass]: directionClass && link })}>
            {direction === 'back' && icon}
            <div className="text">
              <div className="direction">{directionText}</div>
              <div className="label">{label}</div>
            </div>
            {direction === 'next' && icon}
          </div>
        )}
      </Link>
    );
  }
);

export default SectionNavButton;
